module.exports = __webpack_public_path__ + "img/Retail12.dcdd4c3f.png";